export default "__VITE_ASSET__Bypo7ZLK__"